"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteBucketReplicationInput_1 = require("./DeleteBucketReplicationInput");
var DeleteBucketReplicationOutput_1 = require("./DeleteBucketReplicationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.DeleteBucketReplication = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "DeleteBucketReplication",
    http: {
        method: "DELETE",
        requestUri: "/{Bucket}?replication"
    },
    input: {
        shape: DeleteBucketReplicationInput_1.DeleteBucketReplicationInput
    },
    output: {
        shape: DeleteBucketReplicationOutput_1.DeleteBucketReplicationOutput
    },
    errors: []
};
//# sourceMappingURL=DeleteBucketReplication.js.map